import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import type { IBatchSizeSelectorProps, BatchSize } from '@/@types/ai-studio';
import { BATCH_SIZES } from '@/@types/ai-studio';

export function BatchSizeSelector({
  batchSize,
  onBatchSizeChange,
  disabled = false,
  showLabel = true,
}: IBatchSizeSelectorProps) {
  return (
    <div className="flex flex-col gap-2">
      {showLabel && <span className="text-sm font-medium text-foreground">Batch Size</span>}
      <div className="grid grid-cols-4 gap-1.5">
        {BATCH_SIZES.map((size) => {
          const isSelected = batchSize === size;

          return (
            <Button
              key={size}
              type="button"
              variant="ghost"
              size="sm"
              disabled={disabled}
              onClick={() => onBatchSizeChange(size as BatchSize)}
              className={cn(
                'h-9 rounded-lg p-0 text-sm font-medium transition-all border-2',
                isSelected
                  ? 'border-[#B8EF70] bg-muted text-[#B8EF70] hover:bg-muted/80'
                  : 'border-transparent bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
              )}
            >
              {size}
            </Button>
          );
        })}
      </div>
    </div>
  );
}
